/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Bonisoft Backend API
 * Bonisoft Backend API
 * OpenAPI spec version: 1.0
 */

export type CalendarServiceModuleEventModelType = typeof CalendarServiceModuleEventModelType[keyof typeof CalendarServiceModuleEventModelType];


export const CalendarServiceModuleEventModelType = {
  Basic: 'Basic',
  Birthday: 'Birthday',
  Anniversary: 'Anniversary',
  Appointment: 'Appointment',
  Absence: 'Absence',
} as const;
